import { render, staticRenderFns } from "./Alert2Icon.vue?vue&type=template&id=570dec62"
import script from "./Alert2Icon.vue?vue&type=script&lang=js"
export * from "./Alert2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports